"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionModelFieldYesNo = exports.ModelMutatorYesNo = void 0;
var tslib_1 = require("tslib");
var core_api_1 = require("@ikegps/core-api");
var collection_field_1 = require("../collection.field");
var ModelMutatorYesNo = /** @class */ (function (_super) {
    tslib_1.__extends(ModelMutatorYesNo, _super);
    function ModelMutatorYesNo() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ModelMutatorYesNo.prototype.manual = function (newValue) {
        this.state.setFieldValue(this.field.id, newValue);
    };
    return ModelMutatorYesNo;
}(collection_field_1.ModelMutator));
exports.ModelMutatorYesNo = ModelMutatorYesNo;
var CollectionModelFieldYesNo = /** @class */ (function (_super) {
    tslib_1.__extends(CollectionModelFieldYesNo, _super);
    function CollectionModelFieldYesNo() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CollectionModelFieldYesNo.isYesNoField = function (f) {
        return f.schema.type === CollectionModelFieldYesNo.TYPE;
    };
    Object.defineProperty(CollectionModelFieldYesNo.prototype, "Mutator", {
        get: function () {
            if (this._Mutator == null) {
                this._Mutator = new ModelMutatorYesNo(this);
            }
            return this._Mutator;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelFieldYesNo.prototype, "value", {
        get: function () {
            return Boolean(this.stateValue);
        },
        enumerable: false,
        configurable: true
    });
    CollectionModelFieldYesNo.prototype.hasValue = function () {
        return true;
    };
    CollectionModelFieldYesNo.TYPE = core_api_1.IkeFieldType.YES_NO;
    return CollectionModelFieldYesNo;
}(collection_field_1.CollectionModelField));
exports.CollectionModelFieldYesNo = CollectionModelFieldYesNo;
//# sourceMappingURL=yes.no.field.js.map